import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheckCircle,
  faExclamationTriangle,
  faTimesCircle,
  faInfoCircle,
  faTimes,
} from '@fortawesome/free-solid-svg-icons';
import { TOAST_TYPES } from './toastConstants';
import './Toast.css';

/**
 * Icon mapping for each toast type
 */
const TOAST_ICONS = {
  [TOAST_TYPES.SUCCESS]: faCheckCircle,
  [TOAST_TYPES.ERROR]: faTimesCircle,
  [TOAST_TYPES.WARNING]: faExclamationTriangle,
  [TOAST_TYPES.INFO]: faInfoCircle,
};

/**
 * Individual Toast Component
 * Displays a single toast notification with icon, message, and dismiss button
 */
const Toast = ({ toast, onDismiss }) => {
  const { id, type, message, dismissible, action } = toast;

  const handleDismiss = () => {
    if (onDismiss) {
      onDismiss(id);
    }
  };

  const handleAction = () => {
    if (action && action.onClick) {
      action.onClick();
      handleDismiss();
    }
  };

  return (
    <div className={`toast toast-${type}`} role="alert" aria-live="polite">
      <div className="toast-icon">
        <FontAwesomeIcon icon={TOAST_ICONS[type]} />
      </div>
      <div className="toast-content">
        <span className="toast-message">{message}</span>
        {action && (
          <button className="toast-action-btn" onClick={handleAction}>
            {action.label}
          </button>
        )}
      </div>
      {dismissible && (
        <button
          className="toast-dismiss"
          onClick={handleDismiss}
          aria-label="Dismiss notification"
        >
          <FontAwesomeIcon icon={faTimes} />
        </button>
      )}
    </div>
  );
};

export default Toast;
